import actionTypes from "../../actionTypes";

export const setAddUploadCSVLoaderAction = (data) => ({
  type: actionTypes.adminTypes.organizationSettingTypes.SET_UPLOAD_CSV_LOADER,
  payload: data,
});
export const getPasswordExpiryLoaderAction = (data) => ({
  type: actionTypes.adminTypes.organizationSettingTypes
    .GET_PASSWORD_EXPIRY_LOADER,
  payload: data,
});
export const setPasswordExpiryLoaderAction = (data) => ({
  type: actionTypes.adminTypes.organizationSettingTypes
    .SET_PASSWORD_EXPIRY_LOADER,
  payload: data,
});
export const getUserEmailDetailsLoaderAction = (data) => ({
  type: actionTypes.adminTypes.organizationSettingTypes
    .GET_USER_EMAIL_DETAILS_LOADER,
  payload: data,
});
export const addUserEmailDetailsLoaderAction = (data) => ({
  type: actionTypes.adminTypes.organizationSettingTypes
    .ADD_USER_EMAIL_DETAILS_LOADER,
  payload: data,
});
